export default {
  items: null,
  loading: false
}